import { render, staticRenderFns } from "./View-Txt.vue?vue&type=template&id=59b50c85&"
import script from "./View-Txt.vue?vue&type=script&lang=js&"
export * from "./View-Txt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports